export default __webpack_public_path__ + "assets/images/c013dc05e9202f30f9c338f7c8dc00c8.png";